import { logUsage } from 'owa-analytics';
import { getHostApp, MAC_OUTLOOK } from 'owa-config';

const FOCUS_OUTLINE_CSS_CLASS = 'addFocusOutline';
const NAVIGATION_KEYS = ['Tab'];
const ARROW_KEYS = ['ArrowDown', 'ArrowLeft', 'ArrowRight', 'ArrowUp'];

export const tabOutline = { disable: false };

function removeFocusOutlines(this: HTMLBodyElement, ev: MouseEvent) {
    this.classList.remove(FOCUS_OUTLINE_CSS_CLASS);
}

function isTextInput(element: HTMLElement) {
    return (
        element.tagName == 'INPUT' ||
        element.tagName == 'TEXTAREA' ||
        (element.contentEditable && element.contentEditable == 'true')
    );
}

function addFocusOutlinesIfNeeded(this: HTMLBodyElement, ev: KeyboardEvent) {
    if (
        (NAVIGATION_KEYS.indexOf(ev.key) >= 0 && !tabOutline.disable) ||
        (ARROW_KEYS.indexOf(ev.key) >= 0 && !isTextInput(ev.target as HTMLElement))
    ) {
        this.classList.add(FOCUS_OUTLINE_CSS_CLASS);
    } else if (isTextInput(ev.target as HTMLElement)) {
        this.classList.remove(FOCUS_OUTLINE_CSS_CLASS);
    }
}

function disableBrowserContextMenu(this: HTMLBodyElement, ev: MouseEvent) {
    ev.preventDefault();
}

export default function initializeGlobalEventListeners() {
    // disable default browser context menu in Mac OPX host (but still allow custom context menus)
    if (getHostApp() === MAC_OUTLOOK) {
        document.body.addEventListener('contextmenu', disableBrowserContextMenu);
    }

    document.body.addEventListener('mousedown', removeFocusOutlines, true);
    document.body.addEventListener('keydown', addFocusOutlinesIfNeeded, true);
    window?.addEventListener('appinstalled', () => {
        logUsage('PwaInstalled');
    });
}
